// extracted by mini-css-extract-plugin
export default {"wrapper":"BodyTabWrapperNoPadding_wrapper__XeAQs"};